"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@material-ui/core");

var react_1 = __importDefault(require("react"));

var react_router_dom_1 = require("react-router-dom");

require("./BB8Link.scss");

function getIconByType(type) {
  switch (type) {
    case "edit":
      {
        return require("../assets/images/bb8-edit-24px.svg");
      }

    default:
      return require("../assets/images/bb8-keyboard_arrow_right-24px.svg");
  }
}

var BB8Link = function BB8Link(_a) {
  var href = _a.href,
      _b = _a.type,
      type = _b === void 0 ? "arrow" : _b,
      onClick = _a.onClick;

  if (href) {
    return react_1.default.createElement(react_router_dom_1.Link, {
      to: href
    }, react_1.default.createElement("img", {
      className: "bb8-link",
      src: getIconByType(type)
    }));
  }

  return react_1.default.createElement(core_1.IconButton, {
    onClick: onClick
  }, react_1.default.createElement("img", {
    src: getIconByType(type)
  }));
};

exports.default = BB8Link;